// extracted by mini-css-extract-plugin
export default {"blue":"#00a9e0","blueDark":"#0098d8","icon":"IconsAndLabel_icon__ggp1P","blueButton":"IconsAndLabel_blueButton__5fXQh"};